import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalLoaderService } from '@app-core/providers/global-loader.service';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptorService implements HttpInterceptor {

  constructor(private globalLoader: GlobalLoaderService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (request.url.match(/digitalocean\/v2/) && !request.url.match(/metrics/)) {
      this.globalLoader.push();

      return environment.production ?
             next.handle(request)
                 .pipe(finalize(() => {
                   this.globalLoader.pop();
                 })) :
             next.handle(request)
                 .pipe(
                   // materialize(),
                   // delay(1500),
                   // dematerialize(),
                   // tap(console.log),
                   finalize(() => {
                     this.globalLoader.pop();
                   })
                 );
    }

    return next.handle(request);
  }
}
